/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { darken } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

export const useLoginOptionsStyles = makeStyles(theme => ({
  ssoLink: {
    color: theme.palette.tertiary.main,
    textDecoration: 'none',
    fontSize: 'inherit',
    fontFamily: 'inherit',
    fontWeight: 'inherit',
    cursor: 'pointer',
    border: 0,
    background: 'none',
    padding: 0,
    '&:hover': {
      color: darken(theme.palette.tertiary.main, 0.2),
      backgroundColor: 'transparent',
    },
  },
}));
